<template>
  <div class="detalles body-container">
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        
      >
        <v-card-text>
         <div class="loadTitle">
        <img :src="images.logo" /> <label>Cargando...</label>
        </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <b-collapse
      class="card property show"
      animation="slide"
      aria-id="contentIdForA11y3"
      :open="isOpen"
    >
      <template #trigger="props">
        <div
          class="card-header"
          role="button"
          aria-controls="contentIdForA11y3"
        >
          <div class="property-title">
            <h3>
              <strong>Mi propiedad:</strong> {{ productoPrincipal.tipo }}
              {{ productoPrincipal.modelo }} Número
              {{ productoPrincipal.numero }}
            </h3>
          </div>
          <a class="card-header-icon">
            <font-awesome-icon v-if="props.open" :icon="['fa', 'chevron-up']" />
            <font-awesome-icon v-else :icon="['fa', 'chevron-down']" />
          </a>
        </div>
      </template>

      <div class="card-content">
        <div class="content">
          <div class="property-title">
            <h3><strong>N° de Negocio:</strong>{{ project.negocio }}</h3>
          </div>
          <div class="property-buttonsGroup">
            <router-link
              :to="{
                name: 'detalle',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'list']" />Detalles</router-link
            >
            <router-link
              :to="{
                name: 'estado-compra',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'home']" />Estado de
              Compra</router-link
            >
            <router-link
              :to="{
                name: 'avance-obra',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'hourglass-half']" />Avance
              Obra</router-link
            >
            <router-link
              :to="{
                name: 'documentos',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'file']" />Documentos
              Negocio</router-link
            >
            <router-link
              :to="{ name: 'pagos', params: { idNegocio: project.idNegocio } }"
              ><font-awesome-icon
                :icon="['fa', 'dollar-sign']"
              />Pagos</router-link
            >
            <router-link
              :to="{
                name: 'documentos-propiedad',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'map']" />Documentos
              Propiedad</router-link
            >
          </div>
          <b-button
            class="change-btn"
            @click="isCardModalActive = true"
            v-if="proyectos.length > 1"
            ><font-awesome-icon :icon="['fa', 'exchange-alt']" />Cambiar de
            Propiedad</b-button
          >
        </div>
      </div>
      <b-modal v-model="isCardModalActive" :width="640" scroll="keep">
        <div class="card">
          <div class="card-content">
            <div class="misPropiedades-title">
              <h2><span class="bricsa-square"></span>Mis Propiedades</h2>
            </div>
            <div class="misPropiedades-content">
              <div
                class="misPropiedades-item"
                v-for="(misPro, index) in proyectos"
                :key="index"
              >
                <img :src="misPro.image" />
                <label
                  >{{ misPro.productoPrincipal.tipo }}
                  {{ misPro.productoPrincipal.numero }} -
                  {{ misPro.proyecto }}</label
                >
                <h6>
                  <router-link
                    :to="{
                      name: 'detalle',
                      params: { idNegocio: misPro.idNegocio },
                    }"
                    ><strong>N° de negocio:</strong> {{ misPro.negocio }}
                    <i class="far fa-eye"></i
                  ></router-link>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </b-collapse>

    <section class="propiedad">
      <div class="propiedad-container">
        <div class="propiedad-content">
          <div class="propiedad-title">
            <h2><span class="bricsa-square"></span>Mi propiedad</h2>
          </div>
          <b-tabs v-model="activeTab">
            <b-tab-item label="Propiedad">
              <div
                class="propiedades-content"
                v-for="prop in propiedades"
                :key="prop.id"
              >
                <div class="propiedades-info">
                   <v-progress-circular
                    indeterminate
                    color="green"
                    v-show="project_wp.imagen==''"
                  ></v-progress-circular>
                  <div class="">
                    <h2>{{ project.proyecto }}</h2>
                    <h4>
                      {{ productoPrincipal.tipo }}
                      {{ productoPrincipal.modelo }} Número
                      {{ productoPrincipal.numero }}
                    </h4>
                    <p>
                      {{ productoPrincipal.dormitorios }}D
                      {{ productoPrincipal.baños }}B
                    </p>
                    <div
                      v-for="producto in project.productos"
                      :key="producto.idProducto"
                    >
                      <p>{{ producto.tipo }} {{ producto.numero }}</p>
                    </div>
                    <p>Nº de Negocio {{ productoPrincipal.idNegocio }}</p>
                    <p>
                      Superficie útil
                      {{ productoPrincipal.superficeInterior }} mts2
                    </p>
                    <p v-if="productoPrincipal.terraza != ''">
                      Superficie terraza {{ productoPrincipal.terraza }} mts2
                    </p>
                    <p v-show="productoPrincipal.terreno > 0">
                      Superficie total {{ productoPrincipal.terreno }} mts2
                    </p>
                    <div class="propiedades-info__btn">
                      <b-button
                        v-if="modelo_wp.tour"
                        @click="paseoVirtual = true"
                        >360°</b-button
                      ><b-button
                        @click="indexPlantas = 0"
                        v-if="modelo_wp.planta"
                        >Plantas</b-button
                      >
                      <Tinybox
                        v-model="indexPlantas"
                        :images="modelo_wp.planta"
                      ></Tinybox>
                    </div>
                  </div>
                </div>
                <div class="propiedades-img">
                  <v-progress-circular
      indeterminate
      color="primary"
       v-show="project_wp.imagen==''"
    ></v-progress-circular>
                   
                  <img class="loading"
                    :src="project_wp.imagen"
                    v-if="
                      modelo_wp.imagen ==
                      'https://www.bricsa.cl/wp-content/uploads/'
                    "
                  />
                  <img class="loading"
                    :src="modelo_wp.imagen"
                    v-if="
                      modelo_wp.imagen !=
                      'https://www.bricsa.cl/wp-content/uploads/'
                    "
                  />
                </div>
              </div>
              <div class="propiedades-buttons">
                <b-button
                  @click="catVirtual = true"
                  v-if="project_wp.catalogoVirtual"
                  >CATÁLOGO VIRTUAL</b-button
                ><b-button
                  @click="descargarCatalogo(project_wp.brochure)"
                  v-if="project_wp.brochure"
                  >DESCARGAR CATÁLOGO</b-button
                >
              </div>

              <b-modal v-model="catVirtual" width="100%" scroll="keep">
                <div class="card">
                  <div class="card-content">
                    <iframe
                      style="width: 100%; height: 500px"
                      class="embed-responsive-item"
                      :src="modelo_wp.tour"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </b-modal>
              <b-modal v-model="catVirtual" width="100%" scroll="keep">
                <div class="card">
                  <div class="card-content">
                    <iframe
                      style="width: 100%; height: 500px"
                      class="embed-responsive-item"
                      :src="project_wp.catalogoVirtual"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </b-modal>
              <b-modal
                class="paseoVirtual"
                v-model="paseoVirtual"
                width="100%"
                scroll="keep"
              >
                <div class="card">
                  <div class="card-content">
                    <iframe
                      class="embed-responsive-item"
                      :src="modelo_wp.tour"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </b-modal>
              <b-modal v-model="plantas" width="100%" scroll="keep">
                <div class="card">
                  <div class="card-content">
                    <div
                      class="propiedad-plantas"
                      v-for="plant in modelo_wp.planta"
                      :key="plant.id"
                    >
                      <img :src="plant.image" />
                    </div>
                  </div>
                </div>
              </b-modal>
            </b-tab-item>

            <b-tab-item label="Galería" v-if="galerias.length > 0">
              <section class="galeria v-application" id="galeria">
                <v-progress-linear
                  v-if="loading"
                  indeterminate
                  color="cyan"
                ></v-progress-linear>
                <div class="galeria-content">
                  <gallery
                    :images="galerias"
                    :index="index"
                    @close="index = null"
                  ></gallery>
                  <div
                    class="image"
                    id="galeria-img"
                    v-for="(image, imageIndex) in modelo_wp.galeria"
                    :key="imageIndex"
                    @click="index = imageIndex"
                    :style="{
                      backgroundImage: 'url(' + image.image + ')',
                    }"
                  ></div>
                </div>
              </section>
            </b-tab-item>
          </b-tabs>
        </div>
      </div>
    </section>

    <section class="masInfo">
      <div class="masInfo-title">
        <h2>
          <span class="bricsa-square"></span>Más información de tu propiedad
        </h2>
      </div>
      <div class="masInfo-tabs container">
        <router-link
          :to="{
            name: 'detalle',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'list']" />Detalles</router-link
        >
        <router-link
          :to="{
            name: 'estado-compra',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'home']" />Estado de
          Compra</router-link
        >
        <router-link
          :to="{
            name: 'avance-obra',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'hourglass-half']" />Avance
          Obra</router-link
        >
        <router-link
          :to="{
            name: 'documentos',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'file']" />Documentos
          Negocio</router-link
        >
        <router-link
          :to="{ name: 'pagos', params: { idNegocio: project.idNegocio } }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'dollar-sign']" />Pagos</router-link
        >
        <router-link
          :to="{
            name: 'documentos-propiedad',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'map']" />Documentos
          Propiedad</router-link
        >
      </div>
    </section>
    <section class="novedades">
      <div class="novedades-title">
        <h2><span class="bricsa-square"></span>Últimas novedades</h2>
      </div>
      <div class="novedades-content">
        <div class="novedades-item" v-for="nove in destacados" :key="nove.id">
          <div>
            <label>{{ nove.tag }}</label>
            <h2>{{ nove.post_title }}</h2>
          </div>
          <img :src="nove.img" />
          <p>{{ nove.resumen }}</p>
          <router-link
            :to="{ name: 'novedad', params: { name: nove.post_name } }"
            >Seguir leyendo</router-link
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Tinybox from "vue-tinybox";
import VueGallery from "vue-gallery";
import { mapState } from "vuex";
import moment from "moment"; 
import {
  GET_PROJECTS,
  GET_PROJECT,
  GET_PROJECT_WP,
  GET_MODELO_WP,
  GET_PDF,
} from "@/core/services/store/proyecto.module";
import { GET_NOVEDADES } from "@/core/services/store/contenido.module";
moment.locale("es");
export default {
  name: "index",
  components: { gallery: VueGallery, Tinybox },
  data() {
    return {
      images: {
                family: process.env.BASE_URL + 'media/family.jpg',
                logo: process.env.BASE_URL +'media/logo.png',
            },
      loading: true,
      activeTab: 0,
      showBooks: false,
      indexPlantas: -1,
      index: null,
      catVirtual: false,
      paseoVirtual: false,
      plantas: false,
      propiedades: [{}],
      isOpen: false,
      isCardModalActive: false,
    };
  },
  mounted() {
    this.getProjects();
    this.getProject();
    this.getNovedades();
  },
  filters: {
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },

    formatTime(value) {
      const hora = moment(value).format("HH:mm:ss");
      return `${hora}`;
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.loading= true;
    this.$route.params.idNegocio = to.params.idNegocio;
    this.getProjects();
    this.getProject();
    this.getNovedades();
    this.isCardModalActive = false;
    next();
  },
  methods: {
    descargarCatalogo(archivo) {
      this.loading = true;
      const t = this;
      this.$Progress.start();
      this.$store.dispatch(GET_PDF, archivo).then(function (response) {
        t.document = response;
        t.$Progress.finish();
        setTimeout(function () {
          console.log(t.document.data);
          var blob = new Blob([t.document], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.setAttribute("href", URL);
          link.href = url;
          link.setAttribute("download", "catalogo.pdf");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          t.loading = false;
        }, 0);
      });
    },
    abrirCatalogo(archivo) {
      let xhr = new XMLHttpRequest();
      xhr.open("POST", archivo, true);
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      xhr.responseType = "arraybuffer";
      xhr.send();
      xhr.onload = function (e) {
        if (this.status === 200) {
          let blob = new Blob([this.response], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Results.pdf";
          console.log(e);
          link.click();
        }
      };
    },
    getProjects() {
      this.$Progress.start();
      this.$store.dispatch(GET_PROJECTS, null).then(() => {
        (this.loading = false), this.$Progress.finish();
      });
    },
    getProject() {
      const idNegocio = this.$route.params.idNegocio;
      this.$Progress.start();
      this.project_wp.imagen='';
      this.$store.dispatch(GET_PROJECT, idNegocio).then((response) => {
        const idProyecto = response.etapaNav.idProyecto;
        this.getProjectWp(idProyecto);
        this.getModeloWp();
        this.$Progress.finish();
      });
    },
    getProjectWp(sci) {
      this.$Progress.start();
      this.$store.dispatch(GET_PROJECT_WP, sci).then(() => {
        this.$Progress.finish();
      });
    },
    getModeloWp() {
      this.$Progress.start();
      this.$store
        .dispatch(GET_MODELO_WP, this.productoPrincipal.idModelo)
        .then(() => {
          this.$Progress.finish();
        });
    },
    getNovedades() {
      this.$Progress.start();
      this.$store.dispatch(GET_NOVEDADES, null).then(() => {
        this.$Progress.finish();
      });
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.agreement.errors,
      project: (state) => state.proyecto.project,
      projects: (state) => state.proyecto.projects,
      project_wp: (state) => state.proyecto.project_wp,
      modelo_wp: (state) => state.proyecto.modelo_wp,
      novedades: (state) => state.contenido.novedades,
      productoPrincipal: function () {
        if (typeof this.project.productos == "undefined") return {};
        let elementos = this.project.productos;
        return elementos.find((el) => {
          return el.esPrincipal == true;
        });
      },
      productos: function () {
        if (typeof this.project.productos == "undefined") return {};
        let elementos = this.project.productos;
        return elementos.find((el) => {
          return el.esPrincipal == false;
        });
      },
      destacados: function () {
        if (typeof this.novedades.contenidos == "undefined") return {};
        return this.novedades.contenidos.slice(0, 4);
      },
      proyectos: function () {
        if (typeof this.projects.proyectos == "undefined") return [];
        console.log(
          "  +++ " +
            typeof this.projects.proyectos +
            " " +
            this.projects.proyectos
        );
        let elementos = this.projects.proyectos;
        elementos.forEach((item) => {
          item.productoPrincipal = item.productos.find((el) => {
            return el.esPrincipal == true ?? {};
          });
        });
        return elementos;
      },
    }),
    galerias() {
      let galeria = [];
      if (Array.isArray(this.modelo_wp.galeria)) {
        this.modelo_wp.galeria.forEach((item) => {
          galeria.push(item.image);
        });
      }
      return galeria;
    },
  },
};
</script>
<style lang="scss">
.b-tabs {
  .tabs li.is-active a {
    color: var(--bricsa-red) !important;
    border-bottom-color: var(--bricsa-red);
  }
}
</style>

<style lang="scss" scoped>
.property {
  position: absolute;
  padding: 0 6.5%;
  top: 130px;
  z-index: 99;
  width: 100%;
  height: fit-content;
  left: 0;
  background-color: #f5f5f5;
  @media screen and(max-width:1025px) {
    position: fixed;
    top: 119px;
  }
  .property-title {
    h3 {
      color: #4a4a4a;
      font-weight: normal;
      font-size: 16px;
      text-align: left;
    }
    strong {
      color: var(--bricsa-red);
      margin-right: 5px;
    }
  }

  .card-header {
    padding: 10px 24px 5px 19.5px;
    box-shadow: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f5f5f5;
    .card-header-icon {
      color: var(--bricsa-red);
    }
  }
  .card-content {
    padding-top: 0;
    padding-bottom: 0;
    .content {
      display: grid;
      row-gap: 10px;
    }
  }
  .modal {
    .card-content {
      .misPropiedades-title {
        h2 {
          color: #707070;
          font-size: 20px;
          font-weight: bold;
          text-align: left;
          margin: 10px;
          margin-left: 0;
          display: flex;
          align-items: baseline;
          span {
            display: block;
            width: 15px;
            height: 15px;
            margin-right: 5px;
            background: var(--bricsa-red);
          }
        }
      }
      .misPropiedades-content {
        display: grid;
        grid-template-columns: repeat(2, 49%);
        justify-content: space-between;
        row-gap: 10px;
        .misPropiedades-item {
          text-align: left;
          font-size: 13px;
          strong {
            color: var(--bricsa-red);
          }
        }
      }
    }
  }
  .property-buttonsGroup {
    display: grid;
    grid-template-columns: repeat(6, calc(90% / 6));
    justify-content: space-between;
    row-gap: 10px;
    @media screen and(max-width:1025px) {
      grid-template-columns: repeat(3, 32%);
    }
    a {
      padding: 10px 15px;
      text-align: center;
      align-items: center;
      color: #7e7e7e;
      display: grid;
      grid-template-columns: 100%;
      justify-content: center;
      -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      transition: 400ms;
      &:hover {
        background-color: #00457b;
        color: #fff;
      }
      @media screen and(max-width:1024px) {
        font-size: 12px;
      }
      @media screen and(max-width:426px) {
        padding: 5px;
      }
      svg {
        width: 100%;
        height: 30px;
        justify-self: center;
        color: #00457b;
        transition: 400ms;
        &:hover {
          color: #fff;
        }
        @media screen and(max-width:1024px) {
          height: 15px;
        }
      }
    }
  }
  .change-btn {
    background-color: var(--bricsa-red);
    border-radius: 0;
    border: none;
    color: #fff;
    justify-self: flex-end;
    font-size: 14px;
    svg {
      margin-right: 10px;
    }
  }
}

.paseoVirtual {
  width: 100%;
  .card-content {
    height: 90vh;
    iframe {
      width: 100%;
      height: 80vh;
    }
  }
}
.detalles {
  display: grid;
  grid-template-columns: 100%;
  justify-content: space-between;
  row-gap: 30px;
  @media screen and (max-width: 1024px) {
    grid-template-columns: 100%;
  }
  .propiedad {
    grid-column: 1/3;
    @media screen and (max-width: 1024px) {
      grid-column: 1/2;
    }
    .propiedad-container {
      .propiedad-content {
        .propiedad-title {
          h2 {
            color: #707070;
            font-size: 20px;
            font-weight: bold;
            text-align: left;
            margin: 10px;
            margin-left: 0;
            display: flex;
            align-items: baseline;
            span {
              display: block;
              width: 15px;
              height: 15px;
              margin-right: 5px;
              background: var(--bricsa-red);
            }
          }
        }
        .tab-item {
          display: grid;
          row-gap: 20px;
          grid-template-columns: 100%;
          .propiedades-content {
            display: grid;
            grid-template-columns: repeat(2, 49%);
            justify-content: space-between;
            @media screen and (max-width: 1024px) {
              grid-template-columns: 100%;
              row-gap: 20px;
            }
            .propiedades-info {
              font-family: Roboto, sans-serif;
              text-align: left;
              display: grid;
              row-gap: 5px;
              height: fit-content;
              h2 {
                font-size: 26px;
                font-weight: 500;
              }
              h4 {
                font-size: 18px;
                font-weight: 500;
              }
              .propiedades-info__btn {
                display: grid;
                grid-template-columns: repeat(3, min-content);
                button {
                  margin-top: 5px;
                  border-radius: 0;
                  border: none;
                  background: var(--bricsa-red);
                  color: #fff;
                }
              }
            }
          }
          .propiedades-buttons {
            display: flex;
            justify-content: flex-start;
            @media screen and (max-width: 1024px) {
              display: grid;
              grid-template-columns: 100%;
              row-gap: 20px;
            }
            button {
              margin-right: 10px;
              color: #fff;
              background: var(--bricsa-red);
              border-radius: 0;
              border: none;
            }
          }
          .propiedad-plantas {
            width: 100%;
            display: flex;
            justify-content: center;
            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .galeria {
    .galeria-title {
      h2 {
        color: #707070;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        margin: 10px;
        margin-left: 0;
        display: flex;
        align-items: baseline;
        span {
          display: block;
          width: 15px;
          height: 15px;
          margin-right: 5px;
          background: var(--bricsa-red);
        }
      }
    }
    .galeria-content {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(5, 20%);
      justify-content: center;
      row-gap: 10px;
      column-gap: 5px;
      @media screen and(max-width:769px) {
        grid-template-columns: repeat(3, 32.5%);
      }
      #galeria-img {
        background-size: cover;
        width: 100% !important;
        height: 150px !important;
      }
    }
  }
  .novedades {
    grid-column: 1/3;
    @media screen and (max-width: 1024px) {
      grid-column: 1/2;
    }
    .novedades-title {
      h2 {
        color: #707070;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        margin: 10px;
        margin-left: 0;
        display: flex;
        align-items: baseline;
        span {
          display: block;
          width: 15px;
          height: 15px;
          margin-right: 5px;
          background: var(--bricsa-red);
        }
      }
    }
    .novedades-content {
      display: grid;
      grid-template-columns: repeat(4, 23%);
      justify-content: space-between;
      @media screen and (max-width: 1024px) {
        grid-template-columns: repeat(2, 48%);
        row-gap: 20px;
      }
      .novedades-item {
        text-align: left;
        font-family: Roboto, sans-serif;
        display: grid;
        row-gap: 20px;
        height: fit-content;
        label {
          font-weight: 500;
        }
        h2 {
          font-size: 20px;
          font-weight: bold;
          line-height: 1.1;
          overflow: hidden;
          height: calc(1.2rem * 3);
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        p {
          line-height: 1.3;
          overflow: hidden;
          height: calc(1.3rem * 5);
          display: -webkit-box;
          -webkit-line-clamp: 5;
          -webkit-box-orient: vertical;
        }
        a {
          background: var(--bricsa-red);
          padding: 10px 20px;
          color: #fff;
          width: fit-content;
          text-transform: uppercase;
        }
      }
    }
  }
}

.masInfo {
  margin-top: 50px;
  .masInfo-title {
    h2 {
      color: #707070;
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      margin: 10px;
      margin-left: 0;
      display: flex;
      align-items: baseline;
      span {
        display: block;
        width: 15px;
        height: 15px;
        margin-right: 5px;
        background: var(--bricsa-red);
      }
    }
  }
  .masInfo-tabs {
    display: grid;
    grid-template-columns: repeat(6, 16%);
    justify-content: space-between;
    padding: 3% 5%;
    @media screen and (max-width: 1024px) {
      grid-template-columns: repeat(3, 32%);
    }
    .masInfo-tabs__item {
      font-size: 10px;
      padding: 10px;
      height: 100%;
      text-align: center;
      font-weight: bold;
      border: none;
      border-radius: 0px;
      -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      color: var(--bricsa-skiblue);
      align-items: center;
      svg {
        @media screen and (max-width: 769px) {
          height: 15px;
        }
      }
    }
  }
}
</style>